import React from 'react';
import {
  SortColumn,
  SortOrder,
  TableColumn,
} from 'components/Table/Table.types';

import { TableCell, TableHead, TableRow } from '@mui/material';
import { blue } from '@mui/material/colors';

interface TableHeaderProps {
  columns: TableColumn[];
  sortColumn: SortColumn;
  onSort: (sortColumn: SortColumn) => void;
}

const tableCellStyles = {
  ':hover': { cursor: 'pointer', color: blue[700] },
};

class TableHeader extends React.Component<TableHeaderProps> {
  raiseSort = (path: string) => {
    const sortColumn = { ...this.props.sortColumn };
    if (sortColumn.path === path) {
      sortColumn.order =
        sortColumn.order === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
    } else {
      sortColumn.path = path;
      sortColumn.order = SortOrder.ASC;
    }
    this.props.onSort(sortColumn);
  };

  renderSortIcon = (column: TableColumn) => {
    const { sortColumn } = this.props;

    if (column.path !== sortColumn.path) return null;
    if (sortColumn.order === SortOrder.ASC)
      return <i className='fa fa-sort-asc' />;
    return <i className='fa fa-sort-desc' />;
  };

  render() {
    return (
      <TableHead>
        <TableRow selected={true}>
          {this.props.columns.map((column) => (
            <TableCell
              key={column.path || column.key}
              onClick={() => column.path && this.raiseSort(column.path)}
              sx={tableCellStyles}
            >
              {column.label} {this.renderSortIcon(column)}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
}

export default TableHeader;
